// Models
import { UnitConfigViewModel } from '../models/unit-config-view.model';

export namespace UnitConfigActions {
	export class GetAll {
		static readonly type = '[Unit Config] Get Unit Configs';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Unit Config] Set Unit Configs';
		constructor(public configs: UnitConfigViewModel[]) {}
	}

	export class Update {
		static readonly type = '[Unit Config] Update Unit Config';
		constructor(public data: { unitConfig: UnitConfigViewModel; showSpinner?: boolean; showToast?: boolean } = { unitConfig: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateSuccess {
		static readonly type = '[Unit Config] Update Unit Config Success';
		constructor(public unitConfig: UnitConfigViewModel) {}
	}

	export class UpdateError {
		static readonly type = '[Unit Config] Update Unit Config Error';
	}

	export class Delete {
		static readonly type = '[Unit Config] Delete Unit Config';
		constructor(public data: { id: number; showSpinner?: boolean; showToast?: boolean; showConfirm: boolean } = { id: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}
}
